import React, { useState } from "react";

import cx from "classnames";
import { Button, Container, Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import WeaveTopBar from "../../../../../components/WeaveTopBar/WeaveTopBar";
import BackButton from "../../../../../components/BackButton";
import FileUpload from "../../../../../components/FileUpload/FileUpload";
import ApiContext from "../../../../../weaveapi/apicontext";
import SectionInputWidget from "../../../../../components/SectionInputWidget/SectionInputWidget";
import PathHelper from "../../../PathHelper";

import s from "../MarketRegisterPage.module.scss";

export default function MarketChooseKey() {
	const history = useHistory();

	const [publicKey, setPublicKey] = useState(null);
	const [privateKey, setPrivateKey] = useState(null);
	const [, setNickname] = useState(null);

	// ------------------------------------- METHODS -------------------------------------
	const user = {
		name: "Johnny C.",
		publicKey: "acmeMFYwEAYHKoZIzj0CAQYFK4EEAA",
		avatar: "marketUserAvatar",
	};

	const onContinue = () => {
		const { name, publicKey, avatar } = user;

		let params = [];
		if (name) params.push(`name=${name}`);
		if (publicKey) params.push(`publicKey=${publicKey}`);
		if (avatar) params.push(`avatar=${avatar}`);

		history.push({
			pathname: PathHelper.getPath("market", ""),
			search: `?${params.join("&")}`,
		});
	};

	return (
		<div className={s.welcome}>
			<WeaveTopBar />

			<Container fluid className={s.welcomePage}>
				<BackButton />

				<Row className={s.titleContainer}>
					<Col lg="12" sm="12">
						<div className="d-flex align-items-center justify-content-center">
							<p className={s.title}>choose account keys</p>
						</div>
						<div className="d-flex align-items-center justify-content-center">
							<p className={s.howTo}>Learn how to generate keys</p>
						</div>
					</Col>
				</Row>

				{/* Public key */}
				<div style={{ marginTop: 48 }}>
					<FileUpload
						isPublic
						placeholderText="ex. weave4jkhjcfjidsfjksnfds832847194jnal9ssds8.pub"
						accept=".pub"
						verifyContent={ApiContext.verifyKey}
						onFileChange={(k) => {
							try {
								setPublicKey(ApiContext.deriveKeys(k)[0]);
							} catch (e) {}
						}}
						infoText={
							<>
								Choose your public key file here -{" "}
								<span>this key will identify you on the network. </span>
							</>
						}
					/>
				</div>

				{/* Private key */}
				<div style={{ marginTop: 30, marginBottom: 30 }}>
					<FileUpload
						accept=".pvk"
						verifyContent={ApiContext.verifyKey}
						onFileChange={(k) => {
							try {
								setPrivateKey(k);
							} catch (e) {}
						}}
						infoText={
							<>
								Sign with your encrypted private key file here -{" "}
								<span>this key does not leave your local system</span>
							</>
						}
					/>
				</div>

				{/* Nickname */}
				<SectionInputWidget
					icon="user"
					title="Enter a nickname"
					placeholder="ex. Johnny Carson"
					subTitle="Enter a username to identify your public Key"
					onChange={setNickname}
				/>

				<Row className={cx(s.btnContainer, "row")}>
					<Col sm="12" className="d-flex justify-content-center">
						<Button
							color="primary"
							className="btn-default dark"
							disabled={!publicKey || !privateKey}
							onClick={onContinue}
						>
							Continue
						</Button>
					</Col>
				</Row>
			</Container>
		</div>
	);
}
